import type { ReactNode } from 'react';
import type { NavigationMenuItemConfig } from '../hooks';

const NavigationMenuIcon = ({
  config,
  isActive,
  pathname,
}: {
  config: NavigationMenuItemConfig;
  isActive: (pathname: string, key: string, alias?: string) => boolean;
  pathname: string;
}): ReactNode => (isActive(pathname, config.key, config.alias) ? config.activeIcon : config.icon);

export default NavigationMenuIcon;
